import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";

// Components
import Spinner from "../../Components/Loading/Spinner";
import FilterBox from "./Components/FilterBox";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'


export default function ListProducts() {
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [records, setRecords] = useState(50);
    const [skip, setSkip] = useState(0);
    

    // Load users
    useEffect(() => {
        loadProducts()
    }, []);

    useEffect(() => {
        loadProducts()
    }, [records, skip]);

    const handleFilter = (form) => {
        loadProducts(form);
    }

    const handleNextClick = () => {
        if (products.totalRecords <= skip + records) return;
        setSkip(skip + records);
    }
    const handlePreviousClick = () => {
        if (skip === 0) return;
        setSkip(skip - records);
    }

    function loadProducts(form) {
        console.log("loading products...", form);

        var filterText = form ? form.filterText : "";
        var supplierId = form ? form.supplierId : "";
        var type = form ? form.type : "";


        axios
            .get(`https://${process.env.REACT_APP_IP}/api/products/?records=${records}&skip=${skip}&filterText=${filterText}&supplierId=${supplierId}&type=${type}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Products:", res.data);
                setProducts(res.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log("response code: ", err.response.status)
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }

                console.log(err);
                

                
            });
    }

    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                        <h1>Products <button className="btn-sm btn-primary" onClick={() => { navigate(`/Products/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                        <FilterBox filterProducts={handleFilter} />

                            <div className="row" style={{marginBottom:40}}>
                                <div className="col-2"><button onClick={handlePreviousClick} className="btn btn-primary"><FontAwesomeIcon icon={faArrowLeft}/> Back</button></div>
                                <div className="col-8 text-center">Showing {products.recordsSkipped + 1} - {products.recordsSkipped + products.returnedRecords} of {products.totalRecords}</div>
                                <div className="col-2" style={{ textAlign: "right" }} ><button onClick={handleNextClick} className="btn btn-primary">Forward <FontAwesomeIcon icon={faArrowRight} /></button></div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <table style={{width: "100%"}}>
                                        <thead>
                                            <tr>
                                                <th style={{width:120}}>Code</th>
                                                <th style={{ width: 150 }} className="d-none d-md-table-cell">Type</th>
                                                <th>Product</th>
                                                <th>Supplier</th>
                                                <th style={{ width: 100 }} className="d-none d-lg-table-cell">Cost Price</th>
                                                <th style={{ width: 100 }} className="d-none d-lg-table-cell">Sale Price</th>
                                                <th style={{ width: 122 }}>Options</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {products.data && (products.data.map((product) => {
                                                return (
                                                    <tr key={product.id} style={{ cursor: "pointer" }}>
                                                        <td onClick={() => { navigate(`/Products/View/${product.id}`) }}>{product.code}</td>
                                                        <td onClick={() => { navigate(`/Products/View/${product.id}`) }} className="d-none d-md-table-cell">{product.type}</td>
                                                        <td onClick={() => { navigate(`/Products/View/${product.id}`) }}>{product.name}</td>
                                                        <td onClick={() => { navigate(`/Products/View/${product.id}`) }}>{product.supplierName}</td>
                                                        <td onClick={() => { navigate(`/Products/View/${product.id}`) }} className="d-none d-lg-table-cell" style={{textAlign:"right"} }>{product.costPrice.toFixed(2)}</td>
                                                        <td onClick={() => { navigate(`/Products/View/${product.id}`) }} className="d-none d-lg-table-cell" style={{ textAlign: "right" }}>{product.salePrice.toFixed(2)}</td>
                                                        <td>
                                                            <Link to={`/Products/View/${product.id}`} className="btn-sm btn-primary">View</Link>
                                                            <Link to={`/Products/Edit/${product.id}`} className="btn-sm btn-other">Edit</Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }))}
                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: 40 }}>
                                <div className="col-2"><button onClick={handlePreviousClick} className="btn btn-primary"><FontAwesomeIcon icon={faArrowLeft} /> Back</button></div>
                                <div className="col-8 text-center">Showing {products.recordsSkipped + 1} - {products.recordsSkipped + products.returnedRecords} of {products.totalRecords}</div>
                                <div className="col-2" style={{ textAlign: "right" }} ><button onClick={handleNextClick} className="btn btn-primary">Forward <FontAwesomeIcon icon={faArrowRight} /></button></div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
